import * as yup from 'yup';

export const useDeclarationStepFormSchema = () => {
  const schema = yup.object({
    declaration: yup.string().required('Declaration is a required field'),
  });

  return { schema };
};
